import React, { Fragment, useMemo } from 'react'
import FoundLotteryID from './components/FoundLotteryID'
import NotFoundLotteryID from './components/NotFoundLotteryID'
import { NOT_FOUND_LOTTERY_ID } from './constants'

const Scan = ({ lotteries, setLotteries, handleClickRemoveSomeLottery }) => {

  const { notFoundLotteryIds, foundLotteryIds } = useMemo(() => {
    let notFound = []
    let found = []

    lotteries.forEach((lotto, index) => {

      if (lotto.lotteryId === NOT_FOUND_LOTTERY_ID) {
        notFound.push({ ...lotto, index })
      } else {
        found.push({ ...lotto, index })
      }

    })

    return { notFoundLotteryIds: notFound, foundLotteryIds: found }

  }, [lotteries])

  return (
    <Fragment>
      {notFoundLotteryIds.length > 0 && <NotFoundLotteryID lotteries={lotteries} notFoundLotteryIds={notFoundLotteryIds} setLotteries={setLotteries} handleClickRemoveSomeLottery={handleClickRemoveSomeLottery} />}
      {foundLotteryIds.length > 0 && <FoundLotteryID foundLotteryIds={foundLotteryIds} handleClickRemoveSomeLottery={handleClickRemoveSomeLottery} />}
    </Fragment>
  )
}

export default Scan
